import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { Button, Grid, Tooltip } from "@mui/material";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import _ from "lodash";
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import NewBarIcon from '../../../asset/image/NewBarIcon.svg';
import NewPieIcon from '../../../asset/image/NewPieIcon.svg';
import NewDownloadButton from '../../../asset/image/NewDownloadButton.svg';
import CircleIcon from '@mui/icons-material/Circle';
import { getStarlinkUsagePoolPlansChart, getStarlinkUsagePoolServiceLinesChart } from "../../StarlinkReports/slice";
import moment from "moment";
import { TablePaginationActions } from "../../Pagination";

const PieChart = (props) => {
    const { selectedOu, parentPoolId, newSummaryStartDate, newSummaryEndDate, starlinkUsagePoolPlansChart, getStarlinkUsagePoolPlansChart, getStarlinkUsagePoolServiceLinesChart, starlinkUsagePoolServiceLinesChart, planFilter, halfHeight, expand, isPopup, selectedFilter,
        chartRef, selectedTab, setSelectedTab, handleDownload, chartData, setChartData, serviceLinesData, setServiceLinesData, count, setCount, slCount, setSLCount, filters } = props;
    const [titleLeft, setTitleLeft] = useState(0);
    const [page, setPage] = useState(1);
    const rowsPerPage = parseInt('10');
    const [totalCount, setTotalCount] = useState(0);

    const HighchartsInstance = { ...Highcharts };
    Exporting(HighchartsInstance);
    ExportData(HighchartsInstance);
    Highcharts.setOptions({
        exporting: { enabled: false },
    });

    const getUsageSource = () => {
        const endDate = moment(newSummaryEndDate, 'YYYY-MM-DD HH:mm:ss');
        const startDate = moment(newSummaryEndDate, 'YYYY-MM-DD HH:mm:ss');

        const hoursDifference = moment.duration(endDate.diff(startDate)).asHours();
        if (hoursDifference <= 24) {
            return 'aggregation_table';
        } else {
            return 'direct_source';
        }
    }

    const fetchChartDataFn = (page) => {

        const startDate = newSummaryStartDate.format('YYYY-MM-DD');
        const endDate = newSummaryEndDate.format('YYYY-MM-DD');
        const source = getUsageSource();

        const fetchChartData = selectedTab === 'plans'
            ? getStarlinkUsagePoolPlansChart
            : getStarlinkUsagePoolServiceLinesChart;

        fetchChartData(parentPoolId, startDate, endDate, source, planFilter?.plan_id, planFilter?.type, planFilter?.account_number, selectedFilter, filters, page);
    }

    useEffect(() => {
        if (_.isEmpty(planFilter)) return;
        fetchChartDataFn(1);
    }, [newSummaryStartDate, newSummaryEndDate, selectedTab, parentPoolId, planFilter, selectedFilter]);

    useEffect(() => {
        if (selectedOu) {
            setChartData([]);
            setServiceLinesData([]);
            return;
        }
    }, [selectedOu])

    useEffect(() => {
        if(_.isEmpty(planFilter)) {
            setChartData([]);
            setServiceLinesData([]);
            setCount(0);
            setSLCount(0);
            return;
        }
        if (selectedTab == 'plans' && !_.isEmpty(starlinkUsagePoolPlansChart)) {
            setChartData(starlinkUsagePoolPlansChart)
            setCount(starlinkUsagePoolPlansChart?.[0]?.['total_count'])
            // dispatch({type: ACTION_TYPES.GET_STARLINK_USAGE_POOL_PLANS_CHART, payload: {}})
        } else {
            setChartData([]);
            setCount(0)
        }
        if (selectedTab == 'service_lines' && !_.isEmpty(starlinkUsagePoolServiceLinesChart)) {
            setServiceLinesData(starlinkUsagePoolServiceLinesChart);
            setSLCount(starlinkUsagePoolServiceLinesChart?.[0]?.['total_count'])
            // dispatch({type: ACTION_TYPES.GET_STARLINK_USAGE_SERVICE_LINES_CHART, payload: {}})
        } else {
            setServiceLinesData([])
            setSLCount(0)
        }
    }, [starlinkUsagePoolPlansChart, starlinkUsagePoolServiceLinesChart, parentPoolId, planFilter])

    const options = {
        chart: {
            type: 'column',
            height: isPopup ? '350px' : `${((halfHeight * 45) / 100)}px`,
            style: {
                fontFamily: "Roboto, Nunito Sans, Arial, Verdana, Helvetica, sans-serif",
            },
            marginLeft: 80,
            spacingRight: 5,
            plotBorderWidth: 1,
            backgroundColor: 'none',
            events: {
                render: function (this: any) {
                    if (this.plotLeft !== titleLeft) {
                        setTitleLeft(this.plotLeft);
                    }
                },
            }
        },
        colors: ['#2f2282', '#1b51a7', '#3dab97', '#5e3f9e', '#3e88d3', '#1d136a', '#69b8e5', '#3f79ca', '#9e8cc5', '#ed9340',
            '#8cafdf', '#d9914f', '#86c6df', '#3c7df1', '#61cdc0', '#64a1f4', '#dc6161', '#146680', '#2039b5', '#00ad64',
            '#1b4dac', '#b50000', '#8cb5ec', '#c1d5f6', '#b3bbe6', '#e5a8a8', '#f9dabe', '#4b91f1', '#8dbdff', '#efeab9',
            '#8a39a7', '#d9cb4f', '#145f89', '#e7d696', '#8592e7', '#e78585', '#92d7c9', '#aeaeb1', '#755c5d', '#7c6ce6',
            '#cc7460', '#bd9331', '#15e1e8', '#514ced', '#8633de', '#eb52b3', '#c4355b', '#6dc779', '#5373a3', '#8dc293'
        ],
        title: {
            verticalAlign: 'middle',
            floating: true,
            text: '',
            style: {
                color: '#9E9E9E',
                fontFamily: 'Roboto',
                fontSize: '10px',
                fontWeight: '400'
            }
        },
        xAxis: {
            categories: selectedTab === 'plans'
              ? chartData?.map(item => item.name)
              : serviceLinesData?.map(item => `${item?.name}|||${item?.service_line_number}`), 
            type: 'category',
            title: {
              text: ''
            },
            gridLineWidth: 0.5,
            labels: {
              useHTML: true,
              style: {
                width: '100px',
                whiteSpace: 'normal',
                overflow: isPopup ? 'visible' : 'hidden',
                textOverflow: isPopup ? 'unset' : 'ellipsis',
                fontSize: '12px',
                lineHeight: '14px',
              },
              rotation: 0,
              formatter: function (this: any) {
                const rawValue = this?.value;
                const valueStr = typeof rawValue === 'string' ? rawValue : String(rawValue ?? '');
                const [nameOnly] = valueStr.split('|||'); 
                return !isPopup
                  ? `<span 
                      style="max-width:100px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;" 
                      title="${nameOnly}">
                      ${nameOnly}
                  </span>`
                  : nameOnly;
              }
            }
          },          
        yAxis: {
            title: {
                text: 'Usage (GB)',
                offset: 65,
            },
            labels: {
                format: `{value}`,
                enabled: true
            },
            // gridLineDashStyle: 'Dot',
            gridLineWidth: 1,
        },
        tooltip: {
            enabled: true,
            headerFormat: '',
            pointFormat: '<span style="color: #7e8089">{point.name}</span> <br/> <b style="color: #fff">{point.y}</b><br/>',
            valueDecimals: 2,
            useHTML: true,
            borderRadius: 15,
            backgroundColor: '#060606',
            followPointer: false,
            valueSuffix: ' GB',
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                shadow: false,
            },
            column: {
                stacking: false,
                grouping: true,
                allowPointSelect: false,
                cursor: 'pointer',
                shadow: false,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                },
                pointWidth: 20,
            }
        },
        legend: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        exporting: {
            enabled: false,
            csv: {
                columnHeaderFormatter: (item, key) => {
                    if (item.isXAxis) {
                        return 'Time';
                    }
                    return `${item.name} (GB)`;
                }
            }
        },
        series: [{
            data: !_.isEmpty(chartData) && selectedTab == 'plans' ? chartData : !_.isEmpty(serviceLinesData) && selectedTab == 'service_lines' ? serviceLinesData : [],
            dataLabels: {
                enabled: false
            },
            color: '#86c6df',
            size: '100%',
            innerSize: '50%',
        }]
    }

    useEffect(() => {
        if (selectedTab == 'plans') {
            setTotalCount(count);
        } else if (selectedTab == 'service_lines') {
            setTotalCount(slCount);
        }
    }, [count, slCount])

    const colors = ['#2f2282', '#1b51a7', '#3dab97', '#5e3f9e', '#3e88d3', '#1d136a', '#69b8e5', '#3f79ca', '#9e8cc5', '#ed9340',
        '#8cafdf', '#d9914f', '#86c6df', '#3c7df1', '#61cdc0', '#64a1f4', '#dc6161', '#146680', '#2039b5', '#00ad64',
        '#1b4dac', '#b50000', '#8cb5ec', '#c1d5f6', '#b3bbe6', '#e5a8a8', '#f9dabe', '#4b91f1', '#8dbdff', '#efeab9',
        '#8a39a7', '#d9cb4f', '#145f89', '#e7d696', '#8592e7', '#e78585', '#92d7c9', '#aeaeb1', '#755c5d', '#7c6ce6',
        '#cc7460', '#bd9331', '#15e1e8', '#514ced', '#8633de', '#eb52b3', '#c4355b', '#6dc779', '#5373a3', '#8dc293'
    ]

    const handleChangePage = (e, value) => {
        setPage(value);
        fetchChartDataFn(value);
    }

    const handleDisplayDetails = ({ from, to, count }) => {
        return `${from}-${to} of ${count} items`
    }

    const getLabelDisplayedRowsTo = () => {
        if (totalCount === -1) {
            return page * rowsPerPage;
        }
        return rowsPerPage === -1 ? totalCount : Math.min(totalCount, page * rowsPerPage);
    };

    const getAriaLabel = () => { return '' };

    return (
        <div className="new-summary-chart-container" style={{ marginTop: '10px' }}>
            <Grid className='new-summary-chart-component' >
                <Grid >
                    <Grid className="usage-per-site-pie">
                        <Grid className="new-summary-control-limit" style={{ justifyContent: 'space-between', position: !isPopup ? 'absolute' : 'static', top: !isPopup ? expand.isCardExpanded ? '283px' : '200px' : '0', gap: '25px' }}>
                            {/* <Tooltip title='Source : Activity Report'><div className="title-text starlink-usage-pie">Summary</div></Tooltip> */}
                            <Grid className="pieChat-selectTag plan-usage-tabs-pagination">
                                <Grid className="analytics-sub-tabs-container" style={{ paddingLeft: 'unset', marginLeft: `${titleLeft}px`, paddingBottom: '5px', display: 'flex', gap: '8px' }}>
                                    {[{ tabName: 'Pools / Plans', tabValue: 'plans' }, { tabName: 'Service Lines', tabValue: 'service_lines' }].map(subTabValue => (
                                        <Button
                                            key={subTabValue.tabValue}
                                            className="analytics-sub-tabs"
                                            style={{height: '28px'}}
                                            id={subTabValue.tabValue === selectedTab ? 'selectedTab-background' : ''}
                                            onClick={() => {setSelectedTab(subTabValue.tabValue); setServiceLinesData([]); setChartData([]); setPage(1)}}
                                        >
                                            {subTabValue.tabName}
                                        </Button>
                                    ))}
                                </Grid>
                                {isPopup && <Grid className="title-dropdown-pie-chart captive-bar-chart-pagination">
                                    <p className='pagination-selectLabel records-select'>
                                        {handleDisplayDetails({
                                            from: totalCount === 0 ? 0 : (page - 1) * rowsPerPage + 1,
                                            to: getLabelDisplayedRowsTo(),
                                            count: totalCount === -1 ? -1 : totalCount
                                        })}
                                    </p>
                                    <TablePaginationActions
                                        className='pagination-actions'
                                        count={totalCount}
                                        onPageChange={handleChangePage}
                                        page={page}
                                        rowsPerPage={10}
                                        showFirstButton={false}
                                        showLastButton={false}
                                        getItemAriaLabel={getAriaLabel}
                                    />
                                </Grid>}
                            </Grid>
                            <Grid style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                {isPopup && selectedTab == 'plans' && chartData?.length > 0 && <img src={NewDownloadButton} alt="download" onClick={handleDownload} style={{ width: '35px', height: '35px', cursor: 'pointer' }} />}
                                {isPopup && selectedTab == 'service_lines' && serviceLinesData?.length > 0 && <img src={NewDownloadButton} alt="download" onClick={handleDownload} style={{ width: '35px', height: '35px', cursor: 'pointer' }} />}
                            </Grid>
                        </Grid>
                        <div  id={'Starlink-Usage-ColumnChart'}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={options}
                                ref={chartRef}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (state) => ({
    newSummaryStartDate: state?.authReducer?.newSummaryStartDate,
    newSummaryEndDate: state?.authReducer?.newSummaryEndDate,
    starlinkUsagePoolPlansChart: state.starlinkReports.starlinkUsagePoolPlansChart,
    starlinkUsagePoolServiceLinesChart: state.starlinkReports.starlinkUsagePoolServiceLinesChart,
    selectedOu: state.authReducer?.selectedOu
});

export default withRouter(
    connect(mapStateToProps, { getStarlinkUsagePoolPlansChart, getStarlinkUsagePoolServiceLinesChart })(PieChart)
);